import type { ProductConfig } from '@/types/product';
import { franqueabilidadeConfig } from './franqueabilidade';
import { selectConfig } from './select';
import { expansaoConfig } from './expansao';

const PRODUCTS: Record<string, ProductConfig> = {
  franqueabilidade: franqueabilidadeConfig,
  select: selectConfig,
  expansao: expansaoConfig
};

export function getProductFromPath(): ProductConfig {
  const segment = window.location.pathname.split('/')[1] || '';
  return PRODUCTS[segment] ?? PRODUCTS['franqueabilidade'];
}

export { franqueabilidadeConfig, selectConfig, expansaoConfig };
